(function () {
  const section = document.querySelector('.coming-soon');
  if (!section) return;

  const form = section.querySelector('.coming-soon__form');
  if (!form) return;

  const company = section.dataset.klaviyoCompany || '';
  const listId = section.dataset.klaviyoList || '';
  const source = section.dataset.source || 'Coming Soon';

  const emailField = form.querySelector('.coming-soon__field[data-field="email"]');
  const emailInput = form.querySelector('#ComingSoonEmail');
  const emailErrorPlaceholder = form.querySelector('[data-email-error-placeholder]');
  const emailErrorText = form.querySelector('.coming-soon__input-error-text');
  const emailErrorStar = form.querySelector('.coming-soon__input-error-star');
  const consentInput = form.querySelector('#ComingSoonConsent');
  const submit = form.querySelector('.coming-soon__submit');
  const submitDefault = form.querySelector('[data-submit-default]');
  const submitLoading = form.querySelector('[data-submit-loading]');
  const feedback = form.querySelector('[data-feedback]');
  const invalidEmailMessage = 'THE EMAIL IS INVALID';
  const missingEmailMessage = emailInput.dataset.placeholderError || 'EMAIL*';
  const viewportMeta = document.querySelector('meta[name="viewport"]');
  const viewportOriginalContent = viewportMeta ? viewportMeta.getAttribute('content') || '' : '';

  function setLoading(isLoading) {
    submit.disabled = isLoading;
    if (submitDefault && submitLoading) {
      submitDefault.hidden = isLoading;
      submitLoading.hidden = !isLoading;
    }
  }

  function showFeedback(message, state) {
    feedback.textContent = message;
    feedback.dataset.state = state;
  }

  function clearFeedback() {
    feedback.textContent = '';
    delete feedback.dataset.state;
  }

  function showInvalidEmailFeedback() {
    if (emailInput.value.trim()) {
      emailField.dataset.state = 'error';
      emailField.dataset.errorType = 'invalid';
      emailInput.value = '';
      updateEmailPlaceholder();
      showFeedback(invalidEmailMessage, 'error');
    }
  }

  function enableIosInputNoZoom() {
    if (!viewportMeta || !viewportOriginalContent) return;
    const hasMaximumScale = /maximum-scale\s*=/.test(viewportOriginalContent);
    const hasUserScalable = /user-scalable\s*=/.test(viewportOriginalContent);
    let content = viewportOriginalContent;

    if (!hasMaximumScale) {
      content += ', maximum-scale=1';
    }
    if (!hasUserScalable) {
      content += ', user-scalable=no';
    }

    viewportMeta.setAttribute('content', content);
  }

  function restoreViewportMeta() {
    if (!viewportMeta || !viewportOriginalContent) return;
    viewportMeta.setAttribute('content', viewportOriginalContent);
  }

  function showMissingEmailError() {
    emailField.dataset.state = 'error';
    emailField.dataset.errorType = 'missing';
    updateEmailPlaceholder();
    showFeedback(invalidEmailMessage, 'error');
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function updateEmailPlaceholder() {
    const defaultPlaceholder = emailInput.dataset.placeholderDefault || 'EMAIL';
    const hasValue = !!emailInput.value.trim();
    const isError = emailField.dataset.state === 'error';
    const errorType = emailField.dataset.errorType || 'missing';
    const errorLabel = errorType === 'invalid' ? invalidEmailMessage : missingEmailMessage;
    const showStar = errorType !== 'invalid';

    emailInput.placeholder = isError ? errorLabel : defaultPlaceholder;

    if (emailErrorText) {
      emailErrorText.textContent = showStar ? errorLabel.replace(/\*+$/, '') : errorLabel;
    }
    if (emailErrorStar) {
      emailErrorStar.hidden = !showStar;
    }

    if (emailErrorPlaceholder) {
      emailErrorPlaceholder.hidden = !(isError && !hasValue);
    }
  }

  emailInput.addEventListener('input', () => {
    if (emailField.dataset.state === 'error' && emailInput.value.trim()) {
      delete emailField.dataset.state;
      delete emailField.dataset.errorType;
    }
    updateEmailPlaceholder();
    clearFeedback();
  });

  emailInput.addEventListener('blur', updateEmailPlaceholder);
  emailInput.addEventListener('focus', () => {
    const isIosDevice =
      /iPad|iPhone|iPod/.test(window.navigator.userAgent) ||
      (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);

    if (isIosDevice) {
      enableIosInputNoZoom();
    }
  });
  emailInput.addEventListener('blur', restoreViewportMeta);
  if (consentInput) {
    consentInput.addEventListener('change', clearFeedback);
  }

  updateEmailPlaceholder();

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    clearFeedback();

    const email = emailInput.value.trim();

    if (!email || !isValidEmail(email)) {
      if (!email) {
        showMissingEmailError();
      } else {
        showInvalidEmailFeedback();
      }
      emailInput.focus();
      return;
    }

    if (!company || !listId) {
      showInvalidEmailFeedback();
      return;
    }

    setLoading(true);

    try {
      const consented = !!(consentInput && consentInput.checked);
      const headers = {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        revision: '2024-10-15'
      };
      const companyParam = '?company_id=' + encodeURIComponent(company);

      let response;

      if (consented) {
        // Subscribe to list with explicit marketing consent.
        const subscribePayload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: { marketing_consent_explicit: true }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: listId } }
            }
          }
        };

        response = await fetch(
          'https://a.klaviyo.com/client/subscriptions/' + companyParam,
          { method: 'POST', headers: headers, body: JSON.stringify(subscribePayload) }
        );
      } else {
        // No marketing consent — capture profile only, do not add to list.
        const profilePayload = {
          data: {
            type: 'profile',
            attributes: {
              email: email,
              properties: {
                marketing_consent_explicit: false,
                capture_source: source
              }
            }
          }
        };

        response = await fetch(
          'https://a.klaviyo.com/client/profiles/' + companyParam,
          { method: 'POST', headers: headers, body: JSON.stringify(profilePayload) }
        );
      }

      if (response.status === 202 || response.status === 201 || response.status === 409 || response.ok) {
        emailInput.value = 'THANK YOU';
        clearFeedback();
        delete emailField.dataset.state;
        updateEmailPlaceholder();
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'Lead', { content_name: source });
        }
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'sign_up', { method: 'klaviyo', source: source });
        }
      } else {
        showInvalidEmailFeedback();
      }
    } catch (error) {
      showInvalidEmailFeedback();
    } finally {
      setLoading(false);
    }
  });
})();
